import { FormattedMessage } from 'react-intl';
import React from 'react';
import { FULFILLMENTS_DELIVERED_VIEW_ID, FULFILLMENTS_VIEW_ID } from './view-id-constants';

export const FulfillmentsDelivered = {
  label: (
    <FormattedMessage defaultMessage='Delivered' description='shipping page left nav item for in Delivered fulfillments' id='3p0IPz' />
  ),

  expandedDescription: (
    <FormattedMessage
      defaultMessage='Fulfillments / Delivered'
      description='shipments page grid header, fulfillments.delivered'
      id='joNaFT'
    />
  ),

  id: FULFILLMENTS_DELIVERED_VIEW_ID,
  navigationOverride: '/shipments/fulfillments/delivered',
  parentId: FULFILLMENTS_VIEW_ID,
};
